document.addEventListener('DOMContentLoaded', function() {
    console.log("calculatePebbles DOMContentLoaded");

    // Initialize calculators on the page
    initializeCalculators();

    function initializeCalculators() {
        // Check for standalone calculator
        const standaloneCalculator = document.querySelector('.section-pebbles-calculator');
        
        // Check for side panel calculator
        const sidePanelCalculator = document.querySelector('#panel-calculator');
        
        if (standaloneCalculator) {
            console.log("Initializing standalone pebbles calculator");
            setupCalculator({
                containerSelector: '.section-pebbles-calculator',
                isDropdownSelector: true
            });
        }
        
        if (sidePanelCalculator) {
            console.log("Initializing side panel pebbles calculator");
            setupCalculator({
                containerSelector: '#panel-calculator',
                isDropdownSelector: false
            });
        }
        
        // Check if any calculators are found
        if (!standaloneCalculator && !sidePanelCalculator) {
            console.log("No pebbles calculators found on this page");
        } else {
            console.log("Pebbles calculators initialized!");
        }
    }

    function setupCalculator(config) {
        const container = document.querySelector(config.containerSelector);
        if (!container) return;
        
        // Get DOM elements within this calculator
        const lengthInput = container.querySelector('#length');
        const widthInput = container.querySelector('#width');
        const manualAreaInput = container.querySelector('#manual-area');
        const dimensionsSection = container.querySelector('#dimensions-section');
        const manualAreaSection = container.querySelector('#manual-area-section');
        
        // Check for both regular and panel-specific radio buttons
        let calculationTypeRadios = container.querySelectorAll('input[name="calculation-type"]');
        if (calculationTypeRadios.length === 0) {
            calculationTypeRadios = container.querySelectorAll('input[name="pebbles-panel-calculation-type"]');
        }
        
        const recommendedPerSquareMetre = container.querySelector('#recommended_per_square_metre');
        const projectAreaDisplay = container.querySelector('#project-area');
        const totalBagsDisplay = container.querySelector('#total-bags');
        const selectedProductDepth = container.querySelector('#selected-product-depth');
        
        // Check if required elements exist
        if (!recommendedPerSquareMetre || !projectAreaDisplay || !totalBagsDisplay) {
            console.log("Required calculator elements not found in", config.containerSelector);
            return;
        }
        
        // Track which calculation mode is active
        let isUsingDimensions = true;
        
        // Calculate function for this calculator instance
        function calculatePebbles() {
            let area = 0;
            
            // Calculate area based on active calculation mode
            if (isUsingDimensions) {
                // Get input values from dimensions
                const length = parseFloat(lengthInput.value) || 0;
                const width = parseFloat(widthInput.value) || 0;
                
                // Calculate area from dimensions
                area = length * width;
                
                // Update displayed area only in dimensions mode
                if (projectAreaDisplay) {
                    projectAreaDisplay.textContent = area.toFixed(2);
                }
            } else {
                // Get area directly from manual input
                area = parseFloat(manualAreaInput.value) || 0;
                
                // In manual mode, we don't update the project area display
                // because it's hidden and redundant
            }
            
            // Get coverage value based on element type
            let coverageValue = 0;
            if (config.isDropdownSelector && recommendedPerSquareMetre.tagName === 'SELECT') {
                const selectedOption = recommendedPerSquareMetre.options[recommendedPerSquareMetre.selectedIndex];
                coverageValue = parseFloat(selectedOption.value) || 1;
            } else {
                // For hidden input in the side panel
                coverageValue = parseFloat(recommendedPerSquareMetre.value) || 1;
            }
            
            // Calculate number of bags needed
            const numberOfBags = Math.ceil(area * coverageValue);
            totalBagsDisplay.textContent = numberOfBags;
        }
        
        // Get the project area section that contains #project-area
        let projectAreaSection = null;
        const projectAreaSpan = container.querySelector('#project-area');
        if (projectAreaSpan) {
            // Find the parent calculator-section
            projectAreaSection = projectAreaSpan.closest('.calculator-section');
        }
        
        // Function to toggle between calculation modes
        function toggleCalculationMode(mode) {
            console.log("Toggling calculation mode to:", mode);
            isUsingDimensions = (mode === 'dimensions');
            
            if (isUsingDimensions) {
                // Show dimensions, hide manual area
                if (dimensionsSection) {
                    dimensionsSection.style.display = 'block';
                    console.log("Showing dimensions section");
                }
                if (manualAreaSection) {
                    manualAreaSection.style.display = 'none';
                    console.log("Hiding manual area section");
                }
                
                // Show project area since it's calculated from dimensions
                if (projectAreaSection) {
                    projectAreaSection.style.display = 'block';
                }
                
                // Enable dimension inputs
                if (lengthInput) {
                    lengthInput.disabled = false;
                    lengthInput.parentElement.style.opacity = '1';
                }
                if (widthInput) {
                    widthInput.disabled = false;
                    widthInput.parentElement.style.opacity = '1';
                }
                
                // Disable manual area input
                if (manualAreaInput) {
                    manualAreaInput.disabled = true;
                }
            } else {
                // Hide dimensions, show manual area
                if (dimensionsSection) {
                    dimensionsSection.style.display = 'none';
                    console.log("Hiding dimensions section");
                }
                if (manualAreaSection) {
                    manualAreaSection.style.display = 'block';
                    console.log("Showing manual area section");
                }
                
                // Hide project area since it's redundant when entering area manually
                if (projectAreaSection) {
                    projectAreaSection.style.display = 'none';
                }
                
                // Disable dimension inputs
                if (lengthInput) {
                    lengthInput.disabled = true;
                    lengthInput.parentElement.style.opacity = '0.5';
                }
                if (widthInput) {
                    widthInput.disabled = true;
                    widthInput.parentElement.style.opacity = '0.5';
                }
                
                // Enable manual area input
                if (manualAreaInput) {
                    manualAreaInput.disabled = false;
                }
            }
            
            calculatePebbles();
        }
        
        // Add event listeners
        if (lengthInput) lengthInput.addEventListener('input', calculatePebbles);
        if (widthInput) widthInput.addEventListener('input', calculatePebbles);
        if (manualAreaInput) manualAreaInput.addEventListener('input', calculatePebbles);
        
        // Add listeners to radio buttons and initialize the mode
        if (calculationTypeRadios && calculationTypeRadios.length > 0) {
            calculationTypeRadios.forEach(radio => {
                radio.addEventListener('change', function() {
                    console.log("Radio changed to:", this.value);
                    toggleCalculationMode(this.value);
                });
            });
            
            // Initialize the mode based on the checked radio button
            const checkedRadio = container.querySelector('input[name="calculation-type"]:checked');
            if (checkedRadio) {
                console.log("Initial mode:", checkedRadio.value);
                toggleCalculationMode(checkedRadio.value);
            }
        } else {
            console.log("Calculation type radios not found");
        }
        
        // Only add change listener if it's a dropdown select
        if (config.isDropdownSelector && recommendedPerSquareMetre.tagName === 'SELECT') {
            recommendedPerSquareMetre.addEventListener('change', function() {
                // Update depth information when product changes
                const selectedOption = recommendedPerSquareMetre.options[recommendedPerSquareMetre.selectedIndex];
                
                // Get depth from data attribute
                if (selectedProductDepth && selectedOption) {
                    const depth = selectedOption.getAttribute('data-depth') || "50mm";
                    selectedProductDepth.textContent = depth;
                }
                
                calculatePebbles();
            });
            
            // Initialize depth display for dropdown
            if (recommendedPerSquareMetre.options.length > 0 && selectedProductDepth) {
                const initialOption = recommendedPerSquareMetre.options[recommendedPerSquareMetre.selectedIndex];
                const initialDepth = initialOption.getAttribute('data-depth') || "50mm";
                selectedProductDepth.textContent = initialDepth;
            }
        }
        
        // Initialize calculator
        const initialRadio = container.querySelector('input[name="calculation-type"]:checked');
        if (initialRadio) {
            console.log("Setting initial mode to:", initialRadio.value);
            toggleCalculationMode(initialRadio.value);
        } else {
            // Default to dimensions mode if no radio is checked
            toggleCalculationMode('dimensions');
        }
        
        calculatePebbles();
        console.log("Calculator initialized for", config.containerSelector);
    }
});